import moment from "moment-timezone";

export function getPreviousDay(date = new Date()) {
  return addDays(date, -1);
}

export function getNextDay(date = new Date()) {
  return addDays(date, 1);
}

export function addDays(date = new Date(), days: number) {
  const newDate = new Date(date.getTime());
  newDate.setDate(date.getDate() + days);

  return newDate;
}

export function formatDateString(timezoneName: string, dateString: string) {
  var date = new Date(dateString);

  if (timezoneName) {
    return moment(date).tz(timezoneName).format("DD/MM/YYYY HH:mm:ss");
  }
  return moment(date).format("DD/MM/YYYY HH:mm:ss");
}
